import { Primary20SemiBold, Box } from '@sequencehq/core-components'
import { ReactNode } from 'react'

export const StepTitle = ({ children }: { children: ReactNode }) => (
  <Box {...Primary20SemiBold} marginBottom="24px">
    {children}
  </Box>
)
